import { render, staticRenderFns } from "./StoreSuccessfulPayment.vue?vue&type=template&id=961c0338&scoped=true"
import script from "./StoreSuccessfulPayment.vue?vue&type=script&lang=js"
export * from "./StoreSuccessfulPayment.vue?vue&type=script&lang=js"
import style0 from "./StoreSuccessfulPayment.vue?vue&type=style&index=0&id=961c0338&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "961c0338",
  null
  
)

export default component.exports